<template>
  <v-card>
    <v-card-title>
      Sub Menu
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        outlined
        dense
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      sort-by="calories"
      class="elevation-1 ma-3"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>List Data</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#0A7EA5"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                :disabled="!authorize_add"
                v-if="company_id == 1 && role == 'ADMIN'"
              >
                + Create Sub Menu
              </v-btn>
            </template>
            <v-card style="padding: 1rem 0.5rem;">
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text style="padding-bottom: 0;">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.cmd_name"
                        label="Sub Menu Name"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.cmd_route"
                        label="Route Name"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-select
                        v-validate="'required'"
                        :items="mDataArrayGroupMenu"
                        label="กลุ่มเมนู"
                        item-text="cgm_name"
                        item-value="id"
                        v-model="editedItem.group_menu_id"
                        outlined
                        @change="changeSPGroupMenu"
                        required
                        :rules="commonRules"
                        dense
                        hide-details
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model.number="editedItem.cmd_sort_order"
                        label="Sort Order"
                        type="number"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          v-if="authorize_edit && company_id == 1 && role == 'ADMIN'"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
          v-if="authorize_del && company_id == 1 && role == 'ADMIN'"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
  </v-card>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
export default {
  name: "menu-detail",
  data: () => ({
    company_id: localStorage.getItem(server.COMPANYID),
    role: localStorage.getItem(server.ROLE),
    dialog: false,
    search: "",
    dialogDelete: false,
    dialogEdit: false,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    mDataArrayGroupMenu: [],
    commonRules: [(v1) => !!v1 || "This is required"],
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Name", value: "cmd_name" },
      { text: "Route", value: "cmd_route" },
      { text: "Group Menu", value: "cgm_name" },
      { text: "Sort Order", value: "cmd_sort_order" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      cmd_name: "",
      cmd_route: "",
      group_menu_id: 0,
      cmd_sort_order: 0,
      user_create: 0,
      user_update: 0,
      company_id: localStorage.getItem(server.COMPANYID),
    },
    editedItem2: {
      cmd_name: "",
      cmd_route: "",
      group_menu_id: 0,
      cmd_sort_order: 0,
      user_update: 0,
      company_id: localStorage.getItem(server.COMPANYID),
    },
    edit_item_id: 0,
    defaultItem: {
      cmd_name: "",
      cmd_route: "",
      group_menu_id: 0,
      cmd_sort_order: 0,
      user_create: 0,
      user_update: 0,
      company_id: localStorage.getItem(server.COMPANYID),
    },
    fullPage: true,
    authorize_view: false,
    authorize_add: false,
    authorize_edit: false,
    authorize_del: false,
    authorize_id: 0,
  }),
  components: {
    SuccessDialog,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Menu" : "Edit Menu";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
    await this.initialize();
  },
  async mounted() {
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    await this.loadSPGroupMenu();

    // const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },
  methods: {
    async changeSPGroupMenu(selectObj) {
      // console.log(selectObj)
      this.editedItem.group_menu_id = selectObj;
      this.editedItem2.group_menu_id = selectObj;
      //   alert(selectObj);
    },
    async loadSPGroupMenu() {
      // let result = await api.getGroupMenu();
      // this.mDataArrayGroupMenu = result.data;

      // console.log(JSON.stringify(result.data));

      var result;

      // if (localStorage.getItem(server.ROLE) == "ADMIN") {
      //   result = await api.getGroupMenu();
      //   this.mDataArrayGroupMenu = result.data;
      // } else {
      result = await api.getGroupMenu_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      this.mDataArrayGroupMenu = result.data;
      // }
    },
    async initialize() {
      //   alert("initialize");

      // const res_get = await api.getAllDetailGroupMenu();
      // this.desserts = res_get.data;

      var res_get;

      // if (localStorage.getItem(server.ROLE) == "ADMIN") {
      //   res_get = await api.getAllDetailGroupMenu();
      //   this.desserts = res_get.data;
      // } else {
      res_get = await api.getAllDetailGroupMenu_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      this.desserts = res_get.data;
      // }

      // this.$showLoader();
      this.$hideLoader();
      //   console.log("initialize desserts: " + JSON.stringify(res_get.data));
    },

    editItem(item) {
      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      const res_del = await api.deleteMenuDetail(this.edit_item_id);
      if (res_del.status == 200) {
        // alert("debug3");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Delete data success",
          "text-h5 green--text text-center",
        );
        this.initialize();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Delete data Failed",
          "text-h5 red--text text-center",
        );
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedItem.cmd_name == "" || this.editedItem.cmd_name == null) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Sub Menu Name",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (
        this.editedItem.cmd_route == "" ||
        this.editedItem.cmd_route == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Route Name",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (
        this.editedItem.group_menu_id == 0 ||
        this.editedItem.group_menu_id == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input กลุ่มเมนู",
          "text-h5 red--text text-center",
        );
        return;
      }

      this.$showLoader();

      try {
        if (this.editedIndex > -1) {
          this.editedItem2.user_update = localStorage.getItem(server.USER_ID);
          this.editedItem2.cmd_name = this.editedItem.cmd_name;
          this.editedItem2.cmd_route = this.editedItem.cmd_route;
          this.editedItem2.group_menu_id = this.editedItem.group_menu_id;
          this.editedItem2.cmd_sort_order = this.editedItem.cmd_sort_order;

          const res_edit = await api.updateMenuDetail(
            this.edit_item_id,
            this.editedItem2,
          );
          if (res_edit.status == 200) {
            this.setupAlertDialog(
              true,
              "Success",
              "Edit data success",
              "text-h5 green--text text-center",
            );
            this.initialize();
          } else {
            this.setupAlertDialog(
              true,
              "Failed",
              "Edit data Failed",
              "text-h5 red--text text-center",
            );
          }
        } else {
          this.editedItem.user_create = localStorage.getItem(server.USER_ID);
          this.editedItem.company_id = localStorage.getItem(server.COMPANYID);

          const res_add = await api.createMenuDetail(this.editedItem);
          console.log("res_add.data:", JSON.stringify(res_add.data));

          if (res_add.status == 200) {
            const res_all_sgm = await api.getSettingGroupMenu();

            for (let i = 0; i < res_all_sgm.data.length; i++) {
              const newSettingDetail = {
                setting_group_menu_id: res_all_sgm.data[i].id,
                group_menu_id: this.editedItem.group_menu_id,
                menu_detail_id: res_add.data.id,
                company_id: localStorage.getItem(server.COMPANYID),
                smd_view: 0,
                smd_add: 0,
                smd_edit: 0,
                smd_del: 0,
                user_create: localStorage.getItem(server.USER_ID),
                user_update: localStorage.getItem(server.USER_ID),
              };
              await api.createSettingMenuDetail(newSettingDetail);
            }

            this.setupAlertDialog(
              true,
              "Success",
              "Add data success",
              "text-h5 green--text text-center",
            );
            this.initialize();
          } else {
            this.setupAlertDialog(
              true,
              "Failed",
              "Add data Failed",
              "text-h5 red--text text-center",
            );
          }
        }
      } catch (error) {
        console.error("save error:", error);
        this.setupAlertDialog(
          true,
          "Failed",
          "Something went wrong",
          "text-h5 red--text text-center",
        );
      } finally {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.close();
      }
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style></style>
